import Icon from '../components/Icon';

const CollScramble = Icon(
  'coll-scramble',
  <>
    <path d="m9.843 11.593 2.698 1.62.562 2.809.036.183 1.846 1.845 1.098 5.488H.923a.923.923 0 0 1-.913-1.061l.89-5.855a.92.92 0 0 1 .318-.569l1.934-1.623.516-2.837z" />
    <path d="M22.715 14.608a1 1 0 0 1 .043.169l1.23 7.692a.924.924 0 0 1-.91 1.07h-5.74l-1.182-5.913-.036-.182-1.847-1.846-.579-2.895-.053-.267-1.533-.919 2.525-3.03 5.65-.565z" />
    <path d="M11.209.91a.92.92 0 0 1 1.127-.385l3.829 1.491a.92.92 0 0 1 .568.673l.884 4.264-3.357.335-.25.026-2.97 3.562-.856-.513H5.71l1.082-4.871c.06-.272.24-.501.488-.625l2.22-1.11z" />
  </>
);

export default CollScramble;
